import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _regeneratorRuntime from "/vercel/path1/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/vercel/path1/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/vercel/path1/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Avatar, Button, HStack, Heading, Link, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Stack, Text, useColorModeValue, useDisclosure, useToast } from '@chakra-ui/react';
import { supabase, upsertSubscriber } from '../../../services/supabase-client';
import FilterForm from './filter-form';
import NewsletterForm from './join-newsletter-form';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import useSWR from 'swr';
import { useState } from 'react';

var fetchPublishers = function fetchPublishers(organizationId) {
  return new Promise(function (resolve) {
    return supabase.from('publishers').select('id,name,avatar_url').eq('organization_id', organizationId).order('name').then(function (_ref) {
      var data = _ref.data,
          error = _ref.error;
      if (error) throw error;
      return resolve(data);
    });
  });
};

export var Sidebar = function Sidebar(props) {
  var _props$organization$u;

  var router = useRouter();
  var toast = useToast();
  var isSearch = router.pathname.includes('search');

  var _useState = useState(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useDisclosure = useDisclosure(),
      isFilterOpen = _useDisclosure.isOpen,
      onOpenFilter = _useDisclosure.onOpen,
      onCloseFilter = _useDisclosure.onClose;

  var _useDisclosure2 = useDisclosure(),
      isSubscribeOpen = _useDisclosure2.isOpen,
      onOpenSubscribe = _useDisclosure2.onOpen,
      onCloseSubscribe = _useDisclosure2.onClose;

  var _useSWR = useSWR([props.organization.id, 'organizationPublishers'], fetchPublishers),
      publishers = _useSWR.data;

  var _useState2 = useState(null),
      filters = _useState2[0],
      setFilters = _useState2[1];

  var handleFilterChange = function handleFilterChange(values) {
    setFilters(values);
  };

  var handleFilter = function handleFilter() {
    onCloseFilter();
    router.push({
      pathname: '/[slug]/search',
      query: _objectSpread({
        slug: props.organization.slug
      }, filters)
    });
  };

  var handleJoinNewsletter = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              _context.prev = 1;
              _context.next = 4;
              return upsertSubscriber(props.organization.id, values);

            case 4:
              onCloseSubscribe();
              toast({
                title: 'Successfully subscribed',
                status: 'success'
              });
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);

              if (_context.t0.code && _context.t0.code === '23505') {
                toast({
                  title: 'Already subscribed',
                  status: 'info'
                });
                onCloseSubscribe();
              } else {
                toast({
                  title: 'Failed to subscribe',
                  status: 'error'
                });
              }

            case 11:
              _context.prev = 11;
              setIsLoading(false);
              return _context.finish(11);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8, 11, 14]]);
    }));

    return function handleJoinNewsletter(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_jsxs(Stack, {
    spacing: 8,
    px: 4,
    children: [/*#__PURE__*/_jsxs(Stack, {
      spacing: 5,
      children: [!!props.organization.logo_url && /*#__PURE__*/_jsx(Avatar, {
        size: "xl",
        src: props.organization.logo_url,
        name: props.organization.name
      }), /*#__PURE__*/_jsx(Heading, {
        as: "h1",
        fontSize: "xl",
        children: /*#__PURE__*/_jsx(Link, {
          href: (_props$organization$u = props.organization.url) !== null && _props$organization$u !== void 0 ? _props$organization$u : undefined,
          children: props.organization.name
        })
      })]
    }), /*#__PURE__*/_jsxs(Stack, {
      children: [/*#__PURE__*/_jsxs(Text, {
        children: [props.publicationsCount, " articles"]
      }), props.publishersCount > 0 && /*#__PURE__*/_jsxs(Text, {
        children: [props.publishersCount, " publishers"]
      })]
    }), /*#__PURE__*/_jsx(Link, {
      color: "blue.500",
      onClick: onOpenSubscribe,
      children: "Join mailing list"
    }), /*#__PURE__*/_jsxs(HStack, {
      children: [publishers && /*#__PURE__*/_jsx(Button, {
        size: "sm",
        colorScheme: "brand",
        onClick: onOpenFilter,
        children: "Filter"
      }), isSearch && /*#__PURE__*/_jsx(NextLink, {
        href: {
          pathname: '/[slug]',
          query: {
            slug: props.organization.slug
          }
        },
        children: /*#__PURE__*/_jsx(Button, {
          size: "sm",
          variant: "ghost",
          children: "Clear"
        })
      })]
    }), /*#__PURE__*/_jsxs(Modal, {
      isOpen: isSubscribeOpen,
      onClose: onCloseSubscribe,
      children: [/*#__PURE__*/_jsx(ModalOverlay, {}), /*#__PURE__*/_jsxs(ModalContent, {
        children: [/*#__PURE__*/_jsx(ModalHeader, {
          children: "Join our mailing list"
        }), /*#__PURE__*/_jsx(ModalBody, {
          children: /*#__PURE__*/_jsxs(Stack, {
            spacing: 8,
            children: [/*#__PURE__*/_jsx(NewsletterForm, {
              onSubmit: handleJoinNewsletter
            }), /*#__PURE__*/_jsxs(Text, {
              children: ["By subscribing you agree to our", ' ', /*#__PURE__*/_jsx(Link, {
                href: "/terms",
                textDecor: "underline",
                children: "terms"
              }), ' ', "and acknowledge our", ' ', /*#__PURE__*/_jsx(Link, {
                href: "/privacy",
                textDecor: "underline",
                children: "privacy policy"
              }), "."]
            }), /*#__PURE__*/_jsx(NextLink, {
              href: {
                pathname: '[slug]/unsubscribe',
                query: {
                  slug: props.organization.slug
                }
              },
              passHref: true,
              children: /*#__PURE__*/_jsx(Link, {
                fontSize: "sm",
                color: useColorModeValue('gray.600', 'gray.500'),
                children: "Need to unsubscribe?"
              })
            })]
          })
        }), /*#__PURE__*/_jsxs(ModalFooter, {
          children: [/*#__PURE__*/_jsx(Button, {
            mr: 3,
            variant: "ghost",
            onClick: onCloseSubscribe,
            children: "Close"
          }), /*#__PURE__*/_jsx(Button, {
            type: "submit",
            colorScheme: "brand",
            form: "join-newsletter",
            isLoading: isLoading,
            children: "Subscribe"
          })]
        })]
      })]
    }), publishers && /*#__PURE__*/_jsxs(Modal, {
      isOpen: isFilterOpen,
      onClose: onCloseFilter,
      children: [/*#__PURE__*/_jsx(ModalOverlay, {}), /*#__PURE__*/_jsxs(ModalContent, {
        children: [/*#__PURE__*/_jsx(ModalHeader, {
          children: "Filter Articles"
        }), /*#__PURE__*/_jsx(ModalCloseButton, {}), /*#__PURE__*/_jsx(ModalBody, {
          children: /*#__PURE__*/_jsx(FilterForm, {
            publishers: publishers,
            onChange: handleFilterChange
          })
        }), /*#__PURE__*/_jsxs(ModalFooter, {
          children: [/*#__PURE__*/_jsx(Button, {
            mr: 3,
            variant: "ghost",
            onClick: onCloseFilter,
            children: "Close"
          }), /*#__PURE__*/_jsx(Button, {
            colorScheme: "brand",
            onClick: handleFilter,
            children: "Filter"
          })]
        })]
      })]
    })]
  });
};
export default Sidebar;